import "../styles/index.css";
import { initializeTheme } from "./theme.js";
import { initializeRouter } from "./router.js";

console.log("Current environment:", APP_ENV);
console.log("API URL:", API_URL);

initializeTheme();
initializeRouter();
